import { useEffect, useRef } from 'react'
import { MarblingSimulation } from '../lib/marblingSimulation'

function MarblingBackground() {
  const canvasRef = useRef(null)
  const simRef = useRef(null)
  const frameRef = useRef(null)
  const lastTimeRef = useRef(performance.now())

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    let sim
    try {
      sim = new MarblingSimulation(canvas)
      simRef.current = sim
      sim.resize()
    } catch (error) {
      console.error('Failed to initialize marbling simulation:', error)
      return
    }

    const isInsideCanvas = (clientX, clientY) => {
      const rect = canvas.getBoundingClientRect()

      return (
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom
      )
    }
    const handleResize = () => sim.resize()
    const handleMouseMove = (event) => {
      if (isInsideCanvas(event.clientX, event.clientY)) {
        sim.setMouse(event.clientX, event.clientY)
        return
      }

      sim.releasePointer()
    }
    const handlePointerEnd = () => sim.releasePointer()
    const handleDocumentMouseOut = (event) => {
      if (event.relatedTarget === null) {
        sim.releasePointer()
      }
    }
    const handlePointerDown = (event) => {
      if (event.button !== undefined && event.button !== 0) return
      if (!isInsideCanvas(event.clientX, event.clientY)) {
        sim.releasePointer()
        return
      }

      sim.addColorDrop(event.clientX, event.clientY)
    }
    const handleTouchMove = (event) => {
      if (event.touches[0]) {
        sim.setMouse(event.touches[0].clientX, event.touches[0].clientY)
      }
    }

    const animate = (now) => {
      const dt = Math.min((now - lastTimeRef.current) / 1000, 0.033)
      lastTimeRef.current = now
      sim.update(dt)
      frameRef.current = requestAnimationFrame(animate)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('pointerdown', handlePointerDown)
    window.addEventListener('mouseleave', handlePointerEnd)
    window.addEventListener('blur', handlePointerEnd)
    document.addEventListener('mouseout', handleDocumentMouseOut)
    window.addEventListener('touchmove', handleTouchMove, { passive: true })
    window.addEventListener('touchend', handlePointerEnd)
    window.addEventListener('touchcancel', handlePointerEnd)

    frameRef.current = requestAnimationFrame(animate)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('pointerdown', handlePointerDown)
      window.removeEventListener('mouseleave', handlePointerEnd)
      window.removeEventListener('blur', handlePointerEnd)
      document.removeEventListener('mouseout', handleDocumentMouseOut)
      window.removeEventListener('touchmove', handleTouchMove)
      window.removeEventListener('touchend', handlePointerEnd)
      window.removeEventListener('touchcancel', handlePointerEnd)
      if (frameRef.current) cancelAnimationFrame(frameRef.current)
      sim.destroy()
      simRef.current = null
    }
  }, [])

  return <canvas ref={canvasRef} className="marbling-background" aria-hidden="true" />
}

export default MarblingBackground
